import dayjs from "dayjs";
import 'dayjs/locale/uk';
dayjs.locale('uk');


export const formatDate = (dateString: string): string => {
  return dayjs(dateString).format('D MMMM YYYY');
};